import { createRouter, createWebHistory } from "vue-router";

const routes = [
    {
        path: "/report/share-of-shelf",
        component: () => import("@/components/reports/ShareOfShelf.vue"),
        meta: {
            title: "Share of Shelf",
        },
    },
    {
        path: "/report/check-in-check-out",
        component: () => import("@/components/reports/CheckInCheckOut.vue"),
        meta: {
            title: "Check In Check Out",
        },
    },
    {
        path: "/report/ufs-report",
        component: () => import("@/components/reports/OosReport.vue"),
        meta: {
            title: "UFS Report",
        },
    },
    {
        path: "/report/oos-photos",
        component: () => import("@/components/reports/OosPhotos.vue"),
    },
    {
        path: "/report/oos-products",
        component: () => import("@/components/reports/OosProducts.vue"),
    },
    {
        path: "/report/spv-drafts",
        component: () => import("@/components/reports/DraftApproval.vue"),
    },
    {
        path: "/report/raport-misiuni",
        component: () => import("@/components/reports/MissionsReport.vue"),
        meta: {
            title: "Raport Misiuni",
        },
    },
    {
        path: "/report/log-misiuni",
        component: () => import("@/components/reports/MissionLog.vue"),
    },
    {
        path: "/erp/create-location",
        component: () =>
            import("@/components/erp/locations/CreateLocation.vue"),
    },
    {
        path: "/erp/client-photos",
        component: () => import("@/components/erp/ClientPhotos.vue"),
    },
    {
        path: "/erp/locations",
        component: () =>
            import("@/components/erp/locations/IndexLocations.vue"),
    },
    {
        path: "/erp/nps-dashboard",
        component: () => import("@/components/erp/NpsDashboard.vue"),
        meta: {
            title: "NPS",
        },
    },
    {
        path: "/erp/financiar/accounts",
        component: () =>
            import("@/components/erp/financiar/accounts/IndexAccounts.vue"),
    },
    {
        path: "/erp/financiar/unlock-po",
        component: () => import("@/components/erp/financiar/UnlockPo.vue"),
        meta: {
            title: "Deblochează PO",
        },
    },
    {
        path: "/erp/hr/send-sms",
        component: () => import("@/components/erp/SendMailZilieri.vue"),
        meta: {
            title: "Trimite SMS Zilieri",
        },
    },
    {
        path: "/erp/btl/hostess",
        component: () => import("@/components/erp/btl/HostessPhotos.vue"),
        meta: {
            title: "Hostess",
        },
    },
    {
        path: "/erp/edit-photo",
        component: () => import("@/components/erp/EditPhoto.vue"),
        meta: {
            title: "Editează Poza de Profil",
        },
    },
    {
        path: "/erp/btl/rating",
        component: () => import("@/components/erp/btl/HostessRating.vue"),
        meta: {
            title: "Rating Hostess",
        },
    },
    {
        path: "/erp/btl/rating-index",
        component: () => import("@/components/erp/btl/HostessRatingIndex.vue"),
        meta: {
            title: "Rating Hostess",
        },
    },
    {
        path: "/hr/concedii",
        component: () => import("@/components/hr/leaves/EmployeeLeaves.vue"),
        meta: {
            title: "Concedii",
        },
    },
    {
        path: "/hr/siruta",
        component: () => import("@/components/hr/siruta/Siruta.vue"),
        meta: {
            title: "Adaugare SIRUTA",
        },
    },
    {
        path: "/hr/payslips",
        component: () => import("@/components/hr/payslip/Payslips.vue"),
    },
    {
        path: "/erp/locations/edit/:location_id",
        name: "EditLocation",
        component: () => import("@/components/erp/locations/EditLocation.vue"),
        props: true,
        meta: {
            title: "Editare Locație",
        },
    },
    {
        path: "/gdpr",
        name: "gdpr",
        component: () => import("@/components/public/GdprForm.vue"),
    },
    {
        path: "/dove-electric-castle",
        name: "dove-ec",
        component: () => import("@/components/public/DoveForm.vue"),
    },
    {
        path: "/403",
        name: "Forbidden",
        component: () => import("@/views/403.vue"),
        meta: {
            title: "403 Forbidden",
        },
    },
    {
        path: "/404",
        name: "NotFound",
        component: () => import("@/views/404.vue"),
        meta: {
            title: "404 Not Found",
        },
    },
    {
        path: "/maintenance",
        name: "Maintenance",
        component: () => import("@/views/Maintenance.vue"),
    },
    {
        path: "/:catchAll(.*)",
        redirect: "/404",
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.afterEach((to) => {
    const baseTitle = "g7 Sandbox";
    const pageTitle = to.meta.title;

    if (pageTitle) {
        document.title = `${pageTitle} g7`;
    } else {
        document.title = baseTitle;
    }
});

export default router;
